/*  App.tsx  -------------------------------------------------------------- */
import React, { useEffect } from 'react';
import { useAppDispatch } from '../src/redux/hooks';
import { useLocation, useNavigate } from 'react-router-dom';
import { restoreUserSession } from './redux/auth/actions';
import { configureFakeBackend } from './helpers';
import AllRoutes from './routes/Routes';

import './assets/scss/Default.scss';
import './assets/scss/Landing.scss';
import './assets/scss/Icons.scss';

// ------------------------------------------------------------------------

configureFakeBackend();

const CRM_REGEX = /^\/crm(\/.*)?$/;      // "/crm" o cualquier sub-ruta

const App = () => {
  const dispatch = useAppDispatch();
  const location  = useLocation();
  const navigate  = useNavigate();

  /* 1) Restaurar sesión si existe token ------------------------------- */
  useEffect(() => {
    const token   = localStorage.getItem('token');
    const rawUser = localStorage.getItem('user');

    if (token && rawUser) {
      try {
        dispatch(restoreUserSession(JSON.parse(rawUser)));
      } catch (err) {
        console.error(err);
      }
    }
  }, [dispatch]);

  /* 2) Si NO hay token y estamos en /crm/** entonces forzar logout ------ */
useEffect(() => {
  const token = localStorage.getItem('token');
  const path  = location.pathname;

  const isCRM      = CRM_REGEX.test(path);
  const isPublicCRM = ['/crm/privacynew', '/crm/terms', , '/crm/support'].includes(path);

  if (!token && isCRM && !isPublicCRM) {
    navigate('/auth/logout', { replace: true, state: { from: location } });
  }
}, [location.pathname, navigate]);


  /* 3) Guardar la última ruta CRM visitada ------------------------------ */
  useEffect(() => {
    const fullPath = location.pathname + location.search; // incluye ?query
    if (CRM_REGEX.test(fullPath)) {
      localStorage.setItem('lastPath', fullPath);
    }
  }, [location]);

return (
  <>
    <AllRoutes />

  </>
);
};

export default App;
